var BufferLogView = require('bufferlogview');
var InputInfoView = require('inputinfoview');
var ScrollClockView = require('scrollclockview');
var twitch = require('../../lib/twitch.es6');


var BufferScrollView = Backbone.View.extend({
    tagName: 'div',
    className: 'scroll',
    batchSize: 200,
    initialize: function (options) {
        this.setScrolledToBottom(true);
        this.resizing = false;
        
        this.fetching = false;
        
        this.log = new BufferLogView(options, this);
        this.clock = new ScrollClockView(options);
        this.inputInfo = new InputInfoView(options);
        
        this.model.bind('fetched', this.fetched, this);
        this.model.bind('fetchFailed', this.fetchFailed, this);
        this.model.bind('remove', this.remove, this);
        this.model.bind('selectedChange', this.renderSelected, this);
        
        this.model.messages.bind('show', this.showMessage, this);
        this.model.bind('showPending', this.scrollToPending, this);
        
        this.log.bind('scrollChange', this.onChange, this);
    },
    events: {
        'scroll': 'onScroll',
        'buttonClick .loadMore button': 'clickLoadMore'
    },
    setScrolledToBottom: function (value) {
        if (this.scrolledToBottom != value) {
            this.scrolledToBottom = value;
            if (this.recentlyScrolledTimeout) {
                clearTimeout(this.recentlyScrolledTimeout);
            }
            if (this.scrolledToBottom) {
                this.wasRecentlyScrolledToBottom = true;
            } else {
                this.recentlyScrolledTimeout = setTimeout(_.bind(function () {
                    this.wasRecentlyScrolledToBottom = false;
                }, this), 100);
            }
        }
    },
    onScroll: function (e, pinBottom) {
        if (this.isResizing()) {
            return;
        }
        var scrollTop    = this.el.scrollTop;
        var scrollHeight = this.el.scrollHeight;
        if (this.lastScrollTop != scrollTop || this.lastScrollHeight != scrollHeight) {
            this.lastScrollTop    = scrollTop;
            this.lastScrollHeight = scrollHeight;
            if (this.model.isSelected()) {
                this.trigger('scroll', e, pinBottom);
            }
        }
    },
    clickLoadMore: function (e) {
        e.preventDefault();
        this.scrollToTop();
        this.setScrolledToBottom(false);
        this.loadOrRenderBacklog();
    },
    // Called from BufferView
    updateScroll: function () {
        // Update cached value
        if (!this.isResizing()) {
            this.updateScrolledToBottom();
        }
    },
    renderSelected: function () {
        // Unlock focus seen on deselect, in case we deselect while unfocused
        if (!this.model.isSelected()) {
            delete this.lastScrollHeight;
            delete this.lastScrollTop;
            this.unlockFocusSeen();
        }
    },
    unlockFocusSeen: function () {
        this.model.unlockFocusSeen();
        if (!this.log.focusSeenVisible) {
            this.log.removeFocusSeen();
        }
    },
    lockFocusSeen: function () {
        if (this.model.lockFocusSeen()) {
            this.log.renderFocusSeen();
        }
    },
    unlockBottomSeen: function () {
        this.model.unlockBottomSeen();
        if (!this.log.bottomSeenVisible) {
            this.log.removeBottomSeen();
        }
    },
    lockBottomSeen: function () {
        if (this.model.lockBottomSeen()) {
            this.log.renderBottomSeen();
        }
    },
    checkInfiniscroll: function () {
        if (!this.isScrolledToBottom() &&
            !this.isFullyRendered() &&
            this.isScrolledToTop()
        ) {
            this.loadOrRenderBacklog();
        }
    },

    fixScroll: function (pinBottom, animate) {
        if (pinBottom) {
            this.scrollToBottom({
                animate: animate
            });
        } else {
            this.updateScrolledToBottom();
        }
    },
    onChange: function (pinBottom, animate) {
        if (this.model.isSelected() && !this.log.batchRendering) {
            if (this.model.getBottomSeen()) {
                pinBottom = false;
            } else if (pinBottom === undefined) {
                pinBottom = this.isScrolledToBottom();
            }
            // Need to run this first so chatter bar is updated correctly
            if (pinBottom) {
                this.scrollToBottom({
                    animate: animate,
                    silent: true
                });
            }
            this.trigger('change', pinBottom);
            if (this.updateScrollWidth()) {
                this.trigger('widthChange', pinBottom); // if there was a scroll before and isn't now
            }
        }
    },
    // Backlog loading
    isFetching: function () {
        return this.fetching;
    },
    
    getFirstRendered: function () {
        return this.firstRendered;
    },
    setFirstRendered: function (message) {
        if (message) {
            this.firstRendered = message;
            this.log.lineRenderer.firstRender = this.firstRendered;
        }
    },
    clearFirstRendered: function () {
        this.firstRendered = null;
        this.log.lineRenderer.firstRender = this.firstRendered;
    },
    isFullyRendered: function () {
        if (this.model.isDeferred()) {
            return false;
        }
        var firstId = this.model.getFirst();
        if (firstId === 0) {
            // No events
            return true;
        }
        var firstRendered = this.getFirstRendered();
        if (firstRendered) {
            return firstRendered.id == firstId || firstRendered.getMsgId() == firstId;
        }
        return false;
    },
    isFirstMessageRendered: function () {
        var first = this.model.getFirstMessage();
        if (!first || first.equals(this.getFirstRendered())) {
            return true;
        } else {
            return false;
        }
    },
    isLastSeenMessageRendered: function () {
        var lastSeen = this.model.getLastSeenMessage();
        var firstRendered = this.getFirstRendered();
        if (firstRendered && lastSeen && lastSeen.id >= firstRendered.id) {
            return true;
        } else {
            return false;
        }
    },
    
    loadOrRenderBacklog: function () {
        if (this.model.getFirst() !== 0) {
            if (this.isFirstMessageRendered() || this.model.discontinuity) {
                this.loadBacklog();
            } else {
                var firstRendered = this.getFirstRendered();
                var batch;
                if (firstRendered) {
                    batch = this.model.messages.filterBeforeEid(firstRendered.id, this.batchSize);
                    this.log.removeLoadMore();
                    this.fetched(batch, firstRendered.id);
                } else {
                    batch = this.model.messages.last(this.batchSize);
                    this.fetched(batch);
                }
            }
        }
    },
    loadDiscontinuity: function () {
        if (this.isFetching()) {
            return;
        }
        this.fetching = true;
        this.model.loadBacklog(true);
    },
    loadBacklog: function () {
        if (this.isFetching()) {
            return;
        }
        this.fetching = true;
        // Render loading line
        this.log.renderFetching(this.model.isDeferred());
        // Delay fetch to handle scrolling jumpiness
        setTimeout(
            _.bind(this.model.loadBacklog, this.model),
            200
        );
    },
    fetchFailed: function (discontinuity) {
        this.log.renderFetchFailed(discontinuity);
        
        // Set state
        this.fetching = false;
    },
    fetchDone: function (change, pinBottom) {
        this.fetching = false;
        if (change) {
            this.onChange(pinBottom);
        }
        this.trigger('fetched');
    },
    fetched: function (messages, prevEarliest, discontinuity) {
        var atTop, pinBottom;
        if (this.model.isSelected()) {
            if (prevEarliest) {
                atTop = this.isScrolledToTop();
                pinBottom = this.isScrolledToBottom();
            }
        }
        
        var divider = this.log.renderFetched(messages, prevEarliest, discontinuity);

        // Scroll to divider
        if (this.model.isSelected()) {
            if (!prevEarliest) {
                this.fetchDone(true, true);
            } else if (atTop) {
                if (discontinuity || pinBottom) {
                    this.fetchDone(true, pinBottom);
                } else if (divider && divider.length) {
                    var pos = Math.round(divider.position().top);
                    this.scrollTo(pos - 31);
                    this.scrollTo(Math.max(pos - 152, 48), {
                        animate: true,
                        afterAnimate: _.bind(function () {
                            // Recalculate top and scroll to it again, might have moved
                            var pos = Math.round(divider.position().top);
                            this.scrollTo(Math.max(pos - 152, 48));
                            this.fetchDone(true, false);
                        }, this)
                    });
                } else {
                    this.fetchDone(true, false);
                }
            } else {
                this.fetchDone(true, pinBottom);
            }
        } else {
            this.fetchDone();
        }
    },
    // Layout triggers
    onAnimate: function (duration, callback, after) {
        this.isAnimating = true;
        setTimeout(_.bind(function onAnimateTimeout () {
            this.isAnimating = false;
            if (after) {
                after();
            }
        }, this), duration);
        this.checkPinBottom(function (pinBottom) {
            this.onAnimateLoop(pinBottom, callback);
        }, this);
    },
    onAnimateLoop: function (pinBottom, callback) {
        this.setResizing();
        requestAnimationFrame(_.bind(function onAnimateLoopRaf () {
            if (this.isAnimating) {
                this.onAnimateLoop(pinBottom, callback);
            }
            callback(pinBottom);
        }, this));
    },
    // Resizing
    isResizing: function () {
        return this.resizing;
    },
    setResizing: function () {
        this.resizing = true;
        if (this.resizingTimeout) {
            clearTimeout(this.resizingTimeout);
        }
        this.resizingTimeout = setTimeout(_.bind(function () {
            this.resizing = false;
            this.resizingTimeout = null;
            this.checkPinBottom(function (pinBottom) {
                this.onScroll(false, pinBottom);
                this.trigger('resizeEnd');
            }, this);
        }, this), 100);
    },
    render: function () {
        this.stickyAvatarContainer = $('<div class="stickyAvatar authorWrap">');
        if (this.model.connection.isTwitch() && this.model.isChannel()) {
            twitch.bitsAction(this.model.session, this.model.normalise()).then(_.bind(function () {
                this.log.render();
            }, this));
        } else {
            this.log.render();
        }
        $(this.el).append(this.log.el);
        this.clock.render();
        
        this.inputInfo.bubble('makeInputChoice', this);
        this.inputInfo.bubble('makeInputOriginalChoice', this);
        
        return this;
    },
    uncacheRect: function () {
        delete this._rectCache;
    },
    getRect: function () {
        if (this._rectCache) {
            return this._rectCache;
        }
        try {
            this._rectCache = this.el.getBoundingClientRect();
            return this._rectCache;
        } catch (exc) {
            // Crashes in IE11 if element is not in DOM
            return {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: 0,
                height: 0
            };
        }
    },
    setStickyAuthor: function (rows) {
        if (this.model.isSelected()) {
            var ret = this.log.setStickyAuthor(rows);
            if (ret) {
                var avatar = ret[0];
                var top = ret[1];
                var eid = ret[2];
                if (this.stickyAvatar != eid)  {
                    var sticky = avatar.clone().css('top', 0);
                    var parent = avatar.closest('.userParent');
                    var parentData = parent.data();
                    for (var k in parentData) {
                        sticky.attr('data-' + k, parentData[k]);
                    }
                    sticky.removeClass('hasUserParent');
                    sticky.find('.imageAvatar')
                        .addClass('imageAvatar--loading')
                        .removeClass('imageAvatar--error')
                        .removeClass('imageAvatar--loaded');
                    sticky.find('.letterAvatar')
                        .removeClass('letterAvatar--internal_fallback')
                        .removeClass('letterAvatar--external_fallback');
                    this.stickyAvatarContainer.html(sticky);
                    this.stickyAvatar = eid;
                }
                this.stickyAvatarContainer.css({
                    top: top
                });
            } else {
                this.stickyAvatarContainer.empty();
                this.stickyAvatar = null;
            }
        }
    },
    widthChange: function (pinBottom) {
        if (this.updateScrollWidth()) {
            this.uncacheRect();
            if (!this.isResizing()) {
                this.log.resetEmbedClosePositions();
            } else {
                this.unbind('resizeEnd', this.log.resetEmbedClosePositions, this.log);
                this.once('resizeEnd', this.log.resetEmbedClosePositions, this.log);
            }
            this.fixScroll(pinBottom);
        }
    },
    updateScrollWidth: function () {
        var sw = this.el.scrollWidth;
        if (this.scrollWidth != sw) {
            this.scrollWidth = sw;
            return true;
        } else {
            return false;
        }
    },
    updateClock: function (upperMessage) {
        return this.clock.update(upperMessage, this.isScrolledToBottom());
    },
    getMessageForRow: function (row) {
        return this.model.getMessage(row.data('eid'));
    },
    getMessageAtTopOfScroll: function () {
        return this.getMessageForRow(this.log.getRowAtTopOfScroll()[0]);
    },
    rowPositionOffsets: function () {
        return {
            x: 1, // account for left border
            y: 2 + this.clock.getHeight() // account for clock and padding on dates,
        };
    },
    getMessageAtBottomOfScroll: function () {
        return this.getMessageForRow(this.log.getRowAtBottomOfScroll()[0]);
    },
    
    updateScrolledToBottom: function () {
        this.setScrolledToBottom(this.isScrolledToBottom(true));
        return this;
    },
    isScrolledToTop: function () {
        return this.el.scrollTop === 0;
    },
    shouldPinBottom: function () {
        return this.isScrolledToBottom() || this.wasRecentlyScrolledToBottom;
    },
    isScrolledToBottom: function (force) {
        if (force) {
            if (!this.model.isSelected()) {
                return;
            }
            var scrollBottom = this.el.offsetHeight + Math.ceil(this.el.scrollTop); // rounded up cos of browser scaling issues
            return (this.el.scrollHeight - scrollBottom) <= 1; // 1 pixel slop cos of browser scaling issues
        } else {
            return this.scrolledToBottom;
        }
    },
    scrollTo: function (scrollTo, options) {
        options = options || {};
        if (options.animate) {
            $(this.el).animate({
                'scrollTop': scrollTo
            }, {
                duration: 100,
                complete: _.bind(function () {
                    if (options.afterAnimate) {
                        options.afterAnimate();
                    }
                    this.onScroll();
                }, this),
                queue: false
            });
        } else {
            $(this.el).scrollTop(scrollTo);
            if (!options.silent) {
                this.onScroll(false, options.pinBottom);
            }
        }
        return this;
    },
    scrollToTop: function () {
        this.scrollTo(0);
        return this;
    },
    checkPinBottom: function (callback, context, options) {
        options = options || {};
        var pinBottom;
        if (options.checkRecent) {
            pinBottom = this.shouldPinBottom(options);
        } else {
            pinBottom = this.isScrolledToBottom();
        }
        context = context || this;
        callback.call(context, pinBottom);
    },
    scrollToBottom: function (options) {
        options = options || {};
        options.pinBottom = true;
        options.afterAnimate = _.bind(function () {
            // Call it again when we're done in case scroll height changed while animating
            options.animate = false;
            this.scrollToBottom(options);
        }, this);
        this.setScrolledToBottom(true);
        var scrollPos = Math.ceil(this.el.scrollTop); // rounded up cos of browser scaling issues
        var scrollHeight = this.el.scrollHeight;
        var offsetHeight = this.el.offsetHeight;
        var bottom = (scrollHeight - offsetHeight) + 1; // 1px slop for zoomed out browsers
        var atBottom = (bottom - scrollPos) <= 1;

        if (!atBottom) {
            this.scrollTo(bottom, options);
        }
        return this;
    },
    scrollDown: function () {
        if (!this.isScrolledToBottom()) {
            this.scrollTo(this.el.scrollTop + this.el.offsetHeight);
        }
        return this;
    },
    scrollUp: function () {
        if (!this.isScrolledToTop()) {
            this.scrollTo(this.el.scrollTop - this.el.offsetHeight);
        }
        return this;
    },
    showMessage: function (message, options) {
        this.scrollToMessage(message, _.extend({}, options, {strict: true}));
    },
    scrollToMessage: function (message, options) {
        options = options || {};
        var line;
        if (options.strict) {
            line = this.log.getLine(message);
        } else {
            line = this.log.getVisibleLine(message);
        }
        if (line.length && line.is(':visible')) {
            if (options.highlight) {
                line.highlightFlash();
            }
            this.scrollTo(line.position().top - this.clock.getHeight(true));
            return true;
        }
        return false;
    },
    scrollToPending: function (reqId) {
        var row = this.log.getPendingRow(reqId);
        if (row.length) {
            this.scrollTo(row.position().top - this.clock.getHeight(true));
        }
    },
    scrollToLastSeenOrTop: function () {
        var lastSeen = this.model.getLastSeenMessage();
        if (lastSeen && lastSeen.isEmpty()) {
            lastSeen = lastSeen.previousVisible();
        }
        return this.scrollToMessage(lastSeen) || this.scrollToTop();
    },
    scrollToBottomSeenOrBottom: function () {
        var bottomSeen = this.log.getBottomSeen();
        if (bottomSeen.length) {
            var newScrollPos = bottomSeen.position().top - this.clock.getHeight(true);
            var scrollTop = this.el.scrollTop;
            if (newScrollPos - scrollTop <= 1) {
                this.scrollToBottom();
            } else {
                this.scrollTo(newScrollPos);
            }
        } else {
            this.scrollToBottom();
        }
        return this;
    }
});


module.exports = BufferScrollView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferscrollview.js
// module id = kiyR
// module chunks = 1